import 'promise-polyfill/src/polyfill';
import 'whatwg-fetch';

import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faTrash } from '@fortawesome/free-solid-svg-icons';


/* tslint:disable:no-var-requires */
const fontawesome = require('@fortawesome/vue-fontawesome');


import TranslationApiAgent from './services/translation-api-agent';
import AuthApiAgent from '@/services/auth-api-agent';

library.add(faTrash);

Vue.component('font-awesome-icon', fontawesome.FontAwesomeIcon);

Vue.config.productionTip = false;

if (process.env.VUE_APP_REDIRECT === 'true') {
  if (window.location.protocol === 'http:') {
    window.location.href = 'https://' + window.location.host;
  }
}

AuthApiAgent.check().then(({ result }) => {
  AuthApiAgent.isAdmin = result;
  TranslationApiAgent.init(result).then(() => {
    new Vue({
      router,
      store,
      render: (h) => h(<any> App),
    }).$mount('#app');
  });
});
